export default __webpack_public_path__ + "static/media/Ani.7ccb9c74.png";